import { BRACELET_COLORS, BRACELET_NAMES } from "fixtures/play-colors";

export function getPlaygroundState(state) {
  return state.playground;
}

export function getMyProfile(state) {
  return getPlaygroundState(state).playProfile;
}

export function isUserHasPlayProfile(state) {
  return getPlaygroundState(state).hasPlayProfile;
}

export function getProducts(state) {
  const { products } = getPlaygroundState(state);
  return products && products.results;
}

export function getProductCategories(state) {
  const products = getProducts(state);
  return (
    products &&
    products
      .map(item => item.category)
      .filter((item, idx, arr) => arr.indexOf(item) === idx)
  );
}

export function getMissions(state) {
  return getPlaygroundState(state).missions;
}

export function getStandings(state) {
  return getPlaygroundState(state).standings;
}

export function getBraceletColor(state) {
  const profile = getMyProfile(state);
  if (!profile) {
    return undefined;
  }

  return BRACELET_COLORS[profile.group];
}

export function getBraceletName(state) {
  const profile = getMyProfile(state);
  if (!profile) {
    return undefined;
  }

  return BRACELET_NAMES[profile.group];
}

export function getHasClaimedBonus(state) {
  const profile = getMyProfile(state);
  return profile && profile.has_claimed_bonus;
}

export function getMutationsState(state) {
  return getPlaygroundState(state).mutations;
}

export function getMutations(state) {
  const mutationState = getMutationsState(state);
  return mutationState && mutationState.results;
}

export function getMutationsCount(state) {
  const mutationState = getMutationsState(state);
  return mutationState && mutationState.count;
}
